import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Implement a request throttling utility to prevent excessive API calls
const requestThrottles = new Map<string, number>();

/**
 * Utility to determine if a request should be throttled
 * 
 * @param key Unique identifier for the request
 * @param minInterval Minimum time interval between requests (in ms)
 * @returns Boolean indicating if request should be allowed (true) or throttled (false)
 */
export function shouldAllowRequest(key: string, minInterval: number = 5000): boolean {
  const now = Date.now();
  const lastRequestTime = requestThrottles.get(key) || 0;
  const timeSinceLastRequest = now - lastRequestTime;

  if (timeSinceLastRequest < minInterval) {
    console.debug(`Request throttled for key "${key}" - ${timeSinceLastRequest}ms since last call (min: ${minInterval}ms)`);
    return false; // Throttle the request
  }

  // Update the last request time
  requestThrottles.set(key, now);
  return true; // Allow the request
}

/**
 * Mark a request as completed for a specific key
 * @param key Unique identifier for the request
 */
export function markRequestCompleted(key: string): void {
  requestThrottles.set(key, Date.now());
}
